import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    tracesSampleRate: 1.0,
});